export const publications = [
    {
        id: 'currency-vision-ircuwu-2020',
        title:
            'High Tech Vision to Detect Currency Denomination and Virtual Wallet to Retrieve the Monetary Position for Visually Debilitated People',
        type: 'Research publication',
        year: '2020',
        authors: ['N.B.L.K. Perera', 'A.U. Franciscus', 'M.G.R.D. Wickramasinghe'],
        venue: 'IRCUWU 2020 · Proceedings · Uva Wellassa University of Sri Lanka',
        description:
            'Research publication presented at the 4th International Research Conference of Uva Wellassa University (IRCUWU 2020), covering computer vision for currency denomination detection and a virtual wallet for visually impaired people.',
        url: 'https://www.uwu.ac.lk/wp-content/uploads/2020/proceeding_oct_08.pdf',
        relatedProject: null,
    },
    {
        id: 'python-sinhala-book',
        title: 'Python Sinhala Book',
        type: 'Book',
        year: '2020',
        authors: ['Lakshitha Perera'],
        venue: 'Published 2020',
        description:
            'A Sinhala-language book introducing Python programming for beginners, authored by Lakshitha Perera.',
        url: '',
        relatedProject: 'python-sinhala',
    },
    {
        id: 'medium-technical-writing',
        title: 'Technical Writing on Medium',
        type: 'Technical writing',
        year: 'Ongoing',
        authors: ['Lakshitha Perera'],
        venue: 'Medium · @lakshitha1629',
        description:
            'Articles on AI, software engineering, networking, API scalability and load testing.',
        url: 'https://medium.com/@lakshitha1629',
        relatedProject: null,
    },
];

export default publications;
